import { Injectable } from '@angular/core';
import {EndpointService} from '../endpoints.service';
import {StorageService} from '../../@core/services/storage.service';
import {
  _AQH_EVE_1, _AQH_EVE_10, _AQH_EVE_12, _AQH_EVE_13, _AQH_EVE_14, _AQH_EVE_16, _AQH_EVE_17, _AQH_EVE_18, _AQH_EVE_19,
  _AQH_EVE_2, _AQH_EVE_21, _AQH_EVE_22, _AQH_EVE_24, _AQH_EVE_25, _AQH_EVE_26, _AQH_EVE_27,
  _AQH_EVE_3, _AQH_EVE_34, _AQH_EVE_35, _AQH_EVE_5, _AQH_EVE_7, _AQH_EVE_8, _AQH_EVE_9,
  AQH_EVE_0,
  AQH_EVE_1, AQH_EVE_10, AQH_EVE_11, AQH_EVE_12, AQH_EVE_13, AQH_EVE_14, AQH_EVE_15, AQH_EVE_16, AQH_EVE_17, AQH_EVE_18, AQH_EVE_19,
  AQH_EVE_2, AQH_EVE_20, AQH_EVE_21, AQH_EVE_22, AQH_EVE_23, AQH_EVE_24, AQH_EVE_25, AQH_EVE_26, AQH_EVE_27, AQH_EVE_28, AQH_EVE_29, AQH_EVE_30, AQH_EVE_31, AQH_EVE_32, AQH_EVE_33, AQH_EVE_34, AQH_EVE_35,
  AQH_EVE_3,
  AQH_EVE_4, AQH_EVE_5, AQH_EVE_6, AQH_EVE_7, AQH_EVE_8, AQH_EVE_9
} from '../models/input.module';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor(private endpointService: EndpointService,
              private storageService: StorageService) {
  }

  getEvents(params: AQH_EVE_0) {
    return this.endpointService.aqh_eve_0(params).pipe(map((data => {
      return data;
    })))
  }

  addEvent(params: _AQH_EVE_1) {
    let payload: AQH_EVE_1 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_1(payload).pipe(map((data => {
      return data;
    })))
  }

  editEvent(params: _AQH_EVE_2) {
    let payload: AQH_EVE_2 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_2(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEvent(params: _AQH_EVE_3) {
    let payload: AQH_EVE_3 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_3(payload).pipe(map((data => {
      return data;
    })));
  }

  getEventTypes(params: AQH_EVE_4) {
    return this.endpointService.aqh_eve_4(params).pipe(map((data => {
      return data.data;
    })));
  }

  editEventFiles(params: _AQH_EVE_5) {
    let payload: AQH_EVE_5 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_5(payload).pipe(map((data => {
      return data;
    })));
  }

  getEventClasses(params: AQH_EVE_6) {
    return this.endpointService.aqh_eve_6(params).pipe(map((data => {
      return data.data;
    })));
  }

  addEventClass(params: _AQH_EVE_7) {
    let payload: AQH_EVE_7 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_7(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventClass(params: _AQH_EVE_8) {
    let payload: AQH_EVE_8 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_8(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEventClass(params: _AQH_EVE_9) {
    let payload: AQH_EVE_9 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_9(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventClassStatus(params: _AQH_EVE_10) {
    let payload: AQH_EVE_10 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_10(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getEventServices(params: AQH_EVE_11) {
    return this.endpointService.aqh_eve_11(params).pipe(map((data => {
      return data.data;
    })));
  }

  addEventService(params: _AQH_EVE_12) {
    let payload: AQH_EVE_12 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_12(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventService(params: _AQH_EVE_13) {
    let payload: AQH_EVE_13 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_13(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEventService(params: _AQH_EVE_14) {
    let payload: AQH_EVE_14 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_14(payload).pipe(map((data => {
      return data;
    })));
  }

  createSponsor(params: AQH_EVE_15) {
    return this.endpointService.aqh_eve_15(params).pipe(map((data => {
      return data;
    })));
  }

  addSponsorToEvent(params: _AQH_EVE_16) {
    let payload: AQH_EVE_16 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_16(payload).pipe(map((data => {
      return data;
    })));
  }

  addSponsorToEventClass(params: _AQH_EVE_17) {
    let payload: AQH_EVE_17 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_17(payload).pipe(map((data => {
      return data;
    })));
  }

  removeSponsorFromEvent(params: _AQH_EVE_18) {
    let payload: AQH_EVE_18 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_18(payload).pipe(map((data => {
      return data;
    })));
  }

  removeSponsorFromEventClass(params: _AQH_EVE_19) {
    let payload: AQH_EVE_19 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_19(payload).pipe(map((data => {
      return data;
    })));
  }

  uploadSponsorImage(params: AQH_EVE_20) {
    return this.endpointService.aqh_eve_20(params).pipe(map((data => {
      return data;
    })));
  }

  updateSponsor(params: AQH_EVE_23) {
    return this.endpointService.aqh_eve_23(params).pipe(map((data => {
      return data;
    })));
  }

  getEventSponsors(params: _AQH_EVE_21) {
    let payload: AQH_EVE_21 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_21(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getEventClassSponsors(params: _AQH_EVE_22) {
    let payload: AQH_EVE_22 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_22(payload).pipe(map((data => {
      return data.data;
    })));
  }

  getEventContacts(params: _AQH_EVE_24) {
    let payload: AQH_EVE_24 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_24(payload).pipe(map((data => {
      return data.data;
    })));
  }

  addEventContact(params: _AQH_EVE_25) {
    let payload: AQH_EVE_25 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_25(payload).pipe(map((data => {
      return data;
    })));
  }

  editEventContact(params: _AQH_EVE_26) {
    let payload: AQH_EVE_26 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_26(payload).pipe(map((data => {
      return data;
    })));
  }

  deleteEventContact(params: _AQH_EVE_27) {
    let payload: AQH_EVE_27 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_27(payload).pipe(map((data => {
      return data;
    })));
  }

  getEventContactRoles(params: AQH_EVE_28) {
    return this.endpointService.aqh_eve_28(params).pipe(map((data => {
      return data.data;
    })));
  }

  registerForEventClass(params: AQH_EVE_29) {
    return this.endpointService.aqh_eve_29(params).pipe(map((data => {
      return data.data;
    })));
  }

  registerForEventService(params: AQH_EVE_30) {
    return this.endpointService.aqh_eve_30(params).pipe(map((data => {
      return data.data;
    })));
  }

  getUserEventRegistrations(params: AQH_EVE_31) {
    return this.endpointService.aqh_eve_31(params).pipe(map((data => {
      return data.data;
    })));
  }

  cancelEventClassRegistration(params: AQH_EVE_32) {
    return this.endpointService.aqh_eve_32(params).pipe(map((data => {
      return data;
    })));
  }

  cancelEventServiceRegistration(params: AQH_EVE_33) {
    return this.endpointService.aqh_eve_33(params).pipe(map((data => {
      return data;
    })));
  }

  updateEventClassRegistration(params: _AQH_EVE_34) {
    let payload: AQH_EVE_34 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_34(payload).pipe(map((data => {
      return data;
    })));
  }

  updateEventServiceRegistration(params: _AQH_EVE_35) {
    let payload: AQH_EVE_35 = {
      company_id: this.storageService.getSelectedCompanyId(),
      ...params,
    }
    return this.endpointService.aqh_eve_35(payload).pipe(map((data => {
      return data;
    })));
  }
}
